export default defineAppConfig({
  unityAuth: {
    name: 'Hello from Nuxt layer',
  },
})

declare module '@nuxt/schema' {
  interface AppConfigInput {
    unityAuth?: {
      /** Project name */
      name?: string
    }
  }
}
